import React from 'react';
import { FormProvider } from 'react-hook-form';
import Dialog from '@mui/material/Dialog';

import { useSystemsContextProvider } from 'features/systems/context/systems-provider';
import SystemDetailsContent from './components/system-details-content/system-details-content';
import SystemTypeProviderWrapper from './components/system-type-provider-wrapper/system-type-provider-wrapper';

const popUpStyle = {
  style: {
    height: '960px',
    width: '1227px',
    maxWidth: '1227px',
    paddingBottom: '0px',
  },
};

const SystemDetailsPopup = (): React.JSX.Element => {
  const { systemsDetailsHook } = useSystemsContextProvider();
  const { selectedSystem, isDetailsOpen, closeDetails, form } = systemsDetailsHook;

  if (!selectedSystem) {
    return <></>;
  }

  return (
    <Dialog
      open={isDetailsOpen}
      onClose={() => closeDetails()}
      slotProps={{
        paper: popUpStyle,
      }}
    >
      <FormProvider {...form}>
        <SystemTypeProviderWrapper systemType={selectedSystem.type}>
          <SystemDetailsContent systemType={selectedSystem.type} />
        </SystemTypeProviderWrapper>
      </FormProvider>
    </Dialog>
  );
};

export default SystemDetailsPopup;
